import React from "react";
import {
  Home,
  Key,
  Handshake,
  Building2,
  ArrowRight,
  ShieldCheck,
  MapPin,
  Zap,
  Globe,
} from "lucide-react";
import { motion } from "framer-motion";

import { useNavigate } from "react-router-dom";

const RealEstateHero = () => {
  const navigate = useNavigate();

  const actions = [
    { label: "Buy", icon: Home, path: "/buy" },
    { label: "Rent", icon: Key, path: "/rent" },
    { label: "Lease", icon: Handshake, path: "/lease" },
    { label: "Sell", icon: Building2, path: "/sell" },
  ];

  const features = [
    { label: "Verified Listings", icon: ShieldCheck },
    { label: "Prime Locations", icon: MapPin },
    { label: "Fast Deals", icon: Zap },
    { label: "Pan-India Service", icon: Globe },
  ];

  return (
    <section className="relative  text-gray-900 overflow-hidden py-20 px-6 -mt-20">
      
      {/* SUBTLE RED GLOW */}
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-red-100 via-transparent to-transparent pointer-events-none"></div>

      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10 -mt-12">
        
        {/* LEFT */}
        <div>
          <span className="text-red-600 uppercase text-sm tracking-widest font-semibold">
            Our Story
          </span>

          <h1 className="mt-4 text-4xl md:text-6xl font-bold leading-tight">
            Find Homes,
            <br />
            <span className="text-red-600">Delivered Seamlessly.</span>
          </h1>

          <p className="mt-6 text-gray-600 max-w-lg">
            At Housy Hunt, we simplify property discovery by connecting you to
            verified listings, prime locations, and seamless deals. Whether buying,
            renting, or selling — we make real estate effortless.
          </p>

          {/* FEATURES */}
          <div className="grid grid-cols-2 gap-6 mt-10">
            {features.map((item, i) => {
              const Icon = item.icon;
              return (
                <div key={i} className="flex items-center gap-3">
                  <div className="bg-red-100 p-2 rounded-lg">
                    <Icon size={18} className="text-red-600" />
                  </div>
                  <span className="text-gray-700 text-sm font-medium">
                    {item.label}
                  </span>
                </div>
              );
            })}
          </div>

          {/* ACTION BUTTONS */}
          <div className="mt-10 flex flex-wrap gap-4">
            {actions.map((item, index) => {
              const Icon = item.icon;
              return (
                <motion.button
                  key={index}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => navigate(item.path)}
                  className="flex items-center gap-2 px-5 py-3 rounded-full border border-gray-300 hover:bg-red-600 hover:text-white hover:border-red-600 transition cursor-pointer"
                >
                  <Icon size={16} />
                  <span className="font-medium">{item.label}</span>
                  <ArrowRight size={14} />
                </motion.button>
              );
            })}
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="relative">
          
          <img
            src="https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1200"
            className="rounded-2xl w-full h-[420px] object-cover shadow-lg"
            alt="property"
          />

          {/* BADGE */}
          <div className="absolute -top-4 -left-4 bg-red-600 text-white px-4 py-3 rounded-xl font-bold text-sm shadow-lg">
            24/7 Support
          </div>

          {/* FLOATING CARD */}
          <div className="absolute bottom-4 right-4 bg-white border border-gray-200 shadow-md px-4 py-3 rounded-xl text-sm">
            <span className="text-red-600 font-semibold">98.9%</span>
            <p className="text-gray-600 text-xs">Successful Deals</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RealEstateHero;